// ##### Komarov 2025-05-26
import axios from 'axios';
// ##### Komarov 2025-05-26
import { yupResolver } from '@hookform/resolvers/yup';
// ##### Komarov 2025-07-12
import React, { useEffect, useState } from 'react';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import InputMask from 'react-input-mask';
import * as yup from 'yup';
// ##### 25-05-09 Komarov
import { useDispatch, useSelector } from 'react-redux';
import { useLocalizedText } from '../../../hooks/useLocalizedText.js';
import { selectDeviceType } from '../../../Redux/selectors';
// ##### 25-05-10 Komarov
import { getPostObject } from '../../../helpers/crypto';
// ##### 25-05-21 Komarov
import { StarRating } from '../../Library/StaticJsonData/StarRating';
// ##### 25-05-09 Komarov
import { getHotelRates4 } from '../../../Redux/actions';
// ##### 25-05-19 Komarov
import uniqueId from 'lodash.uniqueid';
import moment from 'moment';
import { Toast } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { dateTime } from '../../../helpers/dateFormats';
import { markRequired } from '../../../helpers/markRequired';
import useValidateQuery from '../../../helpers/useValidateQuery';
import config from '../../../Redux/config';
import Pay from '../../Library/LiqPay/Pay';
import SaveReference from '../../Library/Notifications/SaveReference';
// ##### Komarov 2025-07-08
import PropTypes from 'prop-types';
import {
  ClientCategories,
  ClientGenders,
  ClientTitles,
} from '../../Library/StaticJsonData/ClientTitles';
import ConfirmButton from './ConfirmButton';
import IncompleteSendEmail from './IncompleteSendEmail';
import OfflineSummary from './OfflineSummary';
import OnlineSummary from './OnlineSummary';
import TermsConditions from './TermsConditions';
// ##### Komarov 2025-07-08
import { capitalize } from '../../../helpers/capitalize';

// ##### 26-07-30 Komarov
import { smartApiPost as smartPost } from '../../../helpers/smartApiPost';

// ##### Komarov 2025-07-14
const ClientDetailsForm = ({ className }) => {
  const { user: currentUser } = useSelector(state => state.auth);
  const locale = useSelector(state => state.language);

  const isUserRegistered = parseInt(currentUser.user_id) !== 1426;

  // ##### 25-05-19 Komarov
  const buyerData =
    (localStorage.getItem('clientData') &&
      JSON.parse(localStorage.getItem('clientData'))) ||
    {};

  const cart = useValidateQuery();

  // ##### Komarov 2025-07-21
  const [cityTitle, setCityTitle] = useState(decodeURIComponent(cart?.cityName));
  const [hotelTitle, setHotelTitle] = useState(
    decodeURIComponent(cart?.htlName)
  );

  const hotelrates4 = useSelector(state => state.hotelrates.hotelrates4);
  // ##### 25-05-10 Komarov
  const currency = useSelector(state => state.currency);
  const totalCost =
    hotelrates4.data?.prices.rooms[cart?.room_id]?.tariffs[cart?.tariff_id]
      ?.paxes[cart?.pax]?.sum;
  // ##### 25-05-15 Komarov: id валюты контракта текущего отеля
  const hotelCurrencyId = cart?.hotelCurrencyId;
  // ##### 25-05-15 Komarov: курс валюты контракта текущего отеля относительно гривны
  const hotelCurrencyRateToHryvna = currency.currencies.find(item => {
    return item.id == hotelCurrencyId;
  }).value;
  // ##### 25-05-15 Komarov: курс выбранной валюты сайта относительно гривны
  const pickedCurrencyRateToHryvna = currency.currencies.find(item => {
    return item.name == currency.pickedcurrency;
  }).value;
  const [currentCurrencyRate, setCurrentCurrencyRate] = useState(
    pickedCurrencyRateToHryvna
  );
  // ##### 25-05-15 Komarov: устанавливаем первоначальное значение цены заказа
  const [actualAmount, setActualAmount] = useState(
    (totalCost &&
      (totalCost * hotelCurrencyRateToHryvna) / pickedCurrencyRateToHryvna) ||
    cart?.amount
  );
  const starRatingValue = StarRating[cart?.hotel_category.length - 1];
  // ##### 25-05-15 Komarov: локальный state для хранения названия валюты (напр., "UAH")
  const [currencyName, setCurrencyName] = useState(currency.pickedcurrency);

  const [smartServiceData, setSmartServiceData] = useState([{}]);
  const [smartServiceDataErrorMessage, setSmartServiceDataErrorMessage] =
    useState('');
  // ##### Komarov 2025-08-05
  const FirstName = useLocalizedText('FirstName');
  const LastName = useLocalizedText('LastName');
  const PleaseInputBuyerFirstName = useLocalizedText('PleaseInputBuyerFirstName');
  const PleaseInputBuyerLastName = useLocalizedText('PleaseInputBuyerLastName');
  const PleaseInputBuyerPhoneNumber = useLocalizedText('PleaseInputBuyerPhoneNumber');
  const PleaseInputTravelerFirstName = useLocalizedText('PleaseInputTravelerFirstName');
  const PleaseInputTravelerLastName = useLocalizedText('PleaseInputTravelerLastName');
  const ClearForm = useLocalizedText('ClearForm');
  const PleaseAgreeTermsCond = useLocalizedText('PleaseAgreeTermsCond');
  const TravelerInformation = useLocalizedText('TravelerInformation');
  const BuyerNameSurname = useLocalizedText('BuyerNameSurname');
  const BuyerPhoneNumber = useLocalizedText('BuyerPhoneNumber');
  const EnterYourEmailAdddress = useLocalizedText('EnterYourEmailAdddress');
  const PleaseInputBuyerEmail = useLocalizedText('PleaseInputBuyerEmail');
  const PleaseInputValidEmail = useLocalizedText('PleaseInputValidEmail');
  const PleaseInputPhoneNumber = useLocalizedText('PleaseInputPhoneNumber');
  const EmailAddress = useLocalizedText('EmailAddress');
  const BackToRooms = useLocalizedText('BackToRooms');
  const AddTraveler = useLocalizedText('AddTraveler');
  const RemoveTraveler = useLocalizedText('RemoveTraveler');
  const AgeCategory = useLocalizedText('AgeCategory');
  const RequiresClarification = useLocalizedText('RequiresClarification');
  // ##### Komarov 2025-07-08
  const Gender = capitalize(useLocalizedText('RefugeesForm_gender'));

  // ##### 26-07-30 Komarov
  const company_id = useSelector(state => state.auth.user.company_id);
  // ##### 26-07-29 Komarov
  const isB2B = config.b2bCompanyIds.includes(company_id);

  // ##### Komarov 2025-06-03: Схема объекта данных Путешественника
  const travelerItemSchema = yup.object().shape({
    site_client_id: yup.number().required('site_client_id is required'),
    travelerPrefix: yup.string(),
    // ##### Komarov 2025-07-08
    travelerGender: yup.string(),
    travelerCategory: yup.string(),
    travelerFirstName: yup.string().required(PleaseInputTravelerFirstName),
    travelerLastName: yup.string().required(PleaseInputTravelerLastName),
  });

  // ##### Komarov 2025-06-03: Схема объекта данных Формы
  // TODO: Вставить сюда правильные переведённые сообщения о нехватке данных
  const schema = yup.object().shape({
    // ##### 26-07-30 Komarov
    buyerFirstName: isB2B
      ? yup.string()
      : yup.string().required(PleaseInputBuyerFirstName),
    buyerLastName: isB2B
      ? yup.string()
      : yup.string().required(PleaseInputBuyerLastName),
    buyerPhone: isB2B
      ? yup.string()
      : yup.string().required(PleaseInputBuyerPhoneNumber),
    buyerEmail: isB2B
      ? yup.string()
      : yup
          .string()
          .email(PleaseInputValidEmail)
          .required(PleaseInputBuyerEmail),
    buyerComments: yup
      .string()
      .max(512, 'Comments cannot exceed 512 characters'),
    agreedPrice: yup.string(),
    bookForYourself: yup.boolean(),
    shouldCopyName: yup.boolean(),
    travelersData: yup.array().of(travelerItemSchema),
    agreeTermsConditions: yup
      .boolean()
      .oneOf([true], PleaseAgreeTermsCond)
      .required(PleaseAgreeTermsCond),
    registrationTimestamp: yup.date().nullable(),
  });

  // ##### Komarov 2025-06-03: Хук для управлением состоянием всей Формы
  const {
    register, // регистратор дянных формы
    handleSubmit, // обработчик отправки (submit) формы
    control, // переменная привязки кастомных элементов ввода к форме
    formState: { errors }, // состояние формы (данные)
    reset, // функция сброса формы к значениям по умолчанию
    watch, // функция для отслеживания значеий полей формы (watch('bookForYourself') отслеживает значение поля bookForYourself)
    setValue, // функция для установки значения поля формы
  } = useForm({
    resolver: yupResolver(schema), // связываем поля формы со схемой формата и обязательности данных в полях
    // Значения полей формы по умолчанию
    defaultValues: {
      // TODO: Значения формы, которые только для чтения, перенести в это место
      cityTitle,
      hotelTitle,
      actualAmount:
        (actualAmount && Math.fround(actualAmount).toFixed(2)) ||
        'No price was shown',
      starRatingValue,
      RoomType: cart?.room_name,
      Tariff:
        cart?.tariff_type_name +
        (parseInt(cart?.nrf) === 1 ? ' Non Refundable' : ''),
      adults: cart?.adults,
      children: cart?.children,
      numberofunits: cart?.numberofunits,
      currencyName,
      start: cart?.start,
      end: cart?.end,
      buyerPrefix: buyerData?.buyerPrefix || ClientTitles[0],
      buyerFirstName:
        buyerData?.buyerFirstName ||
        (isUserRegistered && currentUser.name) ||
        '',
      buyerLastName:
        buyerData?.buyerLastName ||
        (isUserRegistered && currentUser.surname) ||
        '',
      buyerCategory: buyerData?.buyerCategory || ClientCategories[locale][0],
      buyerPhone: buyerData?.buyerPhone || '', // TODO: Пока нету поля currentUser.phone
      buyerEmail:
        buyerData?.buyerEmail || (isUserRegistered && currentUser.email) || '',
      buyerComments: buyerData?.buyerComments || '',
      agreedPrice: buyerData?.agreedPrice || '',
      bookForYourself: buyerData?.bookForYourself || false,
      shouldCopyName: buyerData?.shouldCopyName || false,
      agreeTermsConditions: buyerData?.agreeTermsConditions || false,
      travelersData: [
        {
          site_client_id: buyerData?.travelersData?.[0].site_client_id || 1,
          // ##### Komarov 2025-07-08
          travelerGender:
            buyerData?.travelersData?.[0].travelerGender || ClientGenders[0],
          travelerCategory:
            buyerData?.travelersData?.[0].travelerCategory ||
            ClientCategories[locale][0],
          travelerPrefix:
            buyerData?.travelersData?.[0].travelerPrefix || ClientTitles[0],
          travelerFirstName:
            buyerData?.travelersData?.[0].travelerFirstName || '',
          travelerLastName:
            buyerData?.travelersData?.[0].travelerLastName || '',
        },
      ],
      registrationTimestamp: null,
    },
  });

  const buyerPrefix = watch('buyerPrefix');
  const buyerFirstName = watch('buyerFirstName');
  const buyerLastName = watch('buyerLastName');
  const buyerCategory = watch('buyerCategory');
  const buyerEmail = watch('buyerEmail');
  const buyerPhone = watch('buyerPhone');
  const buyerComments = watch('buyerComments');
  const agreedPrice = watch('agreedPrice');
  const agreeTermsConditions = watch('agreeTermsConditions');
  const bookForYourself = watch('bookForYourself');
  const shouldCopyName = watch('shouldCopyName');
  // ##### Komarov 2025-07-12
  useEffect(() => {
    setValue(
      `travelersData.${0}.travelerPrefix`,
      (shouldCopyName && buyerPrefix) || ''
    );
    setValue(
      `travelersData.${0}.travelerFirstName`,
      (shouldCopyName && buyerFirstName) || ''
    );
    setValue(
      `travelersData.${0}.travelerLastName`,
      (shouldCopyName && buyerLastName) || ''
    );
    setValue(
      `travelersData.${0}.travelerCategory`,
      (shouldCopyName && buyerCategory) || ''
    );
  }, [shouldCopyName]);

  const {
    fields: travelerFields,
    append: appendTraveler,
    remove: removeTraveler,
  } = useFieldArray({
    control,
    name: 'travelersData',
    schema: travelerItemSchema,
  });

  // ##### Komarov 25-05-23: переменная для хранения обязательного количества Путешественников
  const youNeedTravelersCount = cart?.adults;
  // ##### Komarov 2025-05-23: переменная для хранения количества оставшихся возможных Путешественников
  const [youCanAddTravelersCount, setYouCanAddTravelersCount] = useState(
    cart?.max_adults - youNeedTravelersCount
  );

  // ##### 25-05-09 Komarov
  const company_cipher = useSelector(state => state.whitelabel.company_cipher);
  const promocode = useSelector(state => state.promocode.promocode);
  const deviceType = useSelector(selectDeviceType);
  // ##### Komarov 2025-09-11
  const sale = useSelector(state => state.company.sale_id);

  const dispatch = useDispatch();
  // ##### 2025-09-11 Komarov
  const hotelcontent_loaded = useSelector(
    state => state.hotelcontent.hotelcontent_loaded
  );
  const hotelcontent = useSelector(state => state.hotelcontent.hotelcontent);

  // ##### 25-05-09 Komarov: Отправляем запрос цены отеля по определённому тарифу и категории номера на 4-м этапе поиска (при переходе на Форму Бронирования)
  // ##### Komarov 2025-07-12
  useEffect(() => {
    dispatch(
      getHotelRates4({
        search_data: cart,
        sale: sale || null,
        userId: currentUser.user_id,
        promocode,
        deviceType,
        company_cipher: company_cipher || '',
        refpartner: company_id,
        locale,
        room_rq_id: cart?.room_id,
        tariff_rq_id: cart?.tariff_id,
      })
    );
  }, [
    currentUser.user_id,
    cart?.refpartner,
    cart?.city_id,
    cart?.start,
    cart?.end,
    // ##### 25-02-25 Komarov
    cart?.hotel_id,
    sale,
    deviceType,
    company_cipher,
    cart?.adults,
    cart?.children,
    cart?.rooms,
    locale,
  ]);
  // ##### 25-05-15 Komarov: При изменении выбранной валюты (функцией-хуком useEffect отслеживается значение currency.pickedcurrency в её массиве зависимостей (второй аргумент)) запускаем установку новых значений в локальный state actualAmount, currentCurrencyRate и currencyName (соотв. функциями setActualAmount, setCurrentCurrencyRate и setCurrencyName) (код функции внутри useEffect (первый аргумент))
  useEffect(() => {
    // ##### 25-05-14 Komarov
    if (!actualAmount) return;
    setActualAmount(
      prevAmount =>
        (prevAmount * currentCurrencyRate) / pickedCurrencyRateToHryvna
    );
    setCurrentCurrencyRate(pickedCurrencyRateToHryvna);
    setCurrencyName(currency.pickedcurrency);
  }, [currency.pickedcurrency]);

  const [clicked, setClicked] = useState(false);
  const available_now = cart?.available_now === 'true';
  // ##### 25-05-12 Komarov
  const [registrationTimestamp, setRegistrationTimestamp] = useState();
  const [showTerms, setShowTerms] = useState(false);

  const ReadTermsFunc = () => {
    setShowTerms(!showTerms);
  };

  const closeTermsConditions = () => {
    setShowTerms(false);
  };

  const history = useHistory();

  // ##### 24-06-26 Komarov
  const backToRooms = () => {
    if (localStorage.getItem('urlToBackToRooms')) {
      const urlPart = localStorage.getItem('urlToBackToRooms');
      history.push(`/${locale}${urlPart}`);
    } else {
      history.back();
    }
  };

  // ##### 23-02-20 Komarov: app_service_id - объект, который содержит входные атрибуты после выполнения AddToCart
  let smart_service = new Object();

  // ##### 26-08-12 Komarov
  const isThereDataFromSmart = smartServiceData?.data;
  useEffect(() => {
    if (isThereDataFromSmart) {
      // ##### 24-03-21 Komarov
      for (const key in smartServiceData.data) {
        smart_service = smartServiceData.data[key];
      }
    }
  }, [isThereDataFromSmart]);

  // TODO: Пока нету поля currentUser.phone

  // ##### 23-10-04 Komarov
  const AgreeTermsCond =
    useLocalizedText('AgreeTermsCond') || 'Please agree to Terms and Conditions';

  // ##### 24-04-17 Komarov
  const HotelTitle = useLocalizedText('HotelTitle');
  const RoomType = useLocalizedText('Room type');
  const Tariff = useLocalizedText('Tariff');
  const TotalCostShort = useLocalizedText('TotalCostShort');
  // ##### 24-04-26 Komarov
  const SelectedCurrency = useLocalizedText('SelectedCurrency');
  const Adults = useLocalizedText('Adults');
  const Children = useLocalizedText('Children');
  const Rooms = useLocalizedText('Rooms');
  const Comments = useLocalizedText('Comments');
  // ##### 24-06-11 Komarov
  const AgreedPrice = useLocalizedText('AgreedPrice');
  const CartDetails_3 = useLocalizedText('CartDetails_3'); // Текст "Початок Послуг"
  const CartDetails_4 = useLocalizedText('CartDetails_4'); // Текст "Закінчення Послуг"
  // ##### 24-04-18 Komarov
  const SupplierForm_city = useLocalizedText('SupplierForm_city');
  // ##### 24-04-29 Komarov
  const StarRatingLabelText = useLocalizedText('StarRating');
  const RegistrationDateTime = useLocalizedText('RegistrationDateTime');
  const DoYouBookForYourself = useLocalizedText('DoYouBookForYourself');
  const TravelerName = useLocalizedText('TravelerName');
  const ShouldCopyName = useLocalizedText('ShouldCopyName');
  // ##### 25-05-20 Komarov

  const onSubmit = () => {
    if (smartServiceDataErrorMessage.length > 0) {
      return;
    }
    if (!agreeTermsConditions) {
      setValue('agreeTermsConditions', false, { shouldValidate: true });
      return;
    }

    // Check if booking for someone else and first traveler data is empty
    if (!bookForYourself) {
      const firstTraveler = watch('travelersData.0');
      if (!firstTraveler.travelerFirstName || !firstTraveler.travelerLastName) {
        setValue('travelersData.0.travelerFirstName', '', {
          shouldValidate: true,
        });
        setValue('travelersData.0.travelerLastName', '', {
          shouldValidate: true,
        });
        return;
      }
    }

    setClicked(Object.keys(errors).length === 0);
  };

  useEffect(() => {
    if (!hotelcontent_loaded) return;
    // ##### 25-05-12 Komarov
    if (!hotelcontent.data?.hotels[cart?.id]) return;
    setCityTitle(hotelcontent.data.ci_title);
    setHotelTitle(hotelcontent.data.hotels[cart?.id].ho_title);
  }, [locale, hotelcontent_loaded]);

  useEffect(() => {
    // Добавить недостающих обязательных путешественников
    if (travelerFields.length < youNeedTravelersCount) {
      const currentIds = travelerFields.map(t => t?.site_client_id || 0);
      let maxId = currentIds.length > 0 ? Math.max(...currentIds) : 0;
      for (let i = travelerFields.length; i < youNeedTravelersCount; i++) {
        maxId += 1;
        appendTraveler({
          site_client_id: maxId,
          travelerPrefix: ClientTitles[0],
          // ##### Komarov 2025-07-08
          travelerGender: ClientGenders[0],
          travelerCategory: ClientCategories[locale][0],
          travelerFirstName: '',
          travelerLastName: '',
        });
      }
    }
    // Не удаляем лишних! Пользователь может добавить больше путешественников вручную.
  }, [youNeedTravelersCount, travelerFields.length]);

  const getFormFieldsCount = formDataObject => {
    let count = 0;
    for (const key in formDataObject) {
      if (typeof formDataObject[key] !== 'object') {
        count++;
      } else if (
        formDataObject[key] !== null &&
        formDataObject[key].length &&
        formDataObject[key].length > 0
      ) {
        count += formDataObject[key].length;
      }
    }
    return count;
  };

  const watchedFormData = watch();
  const formFieldsCount = getFormFieldsCount(watchedFormData);

  // ##### 25-04-30 Komarov
  useEffect(() => {
    localStorage.setItem('clientData', JSON.stringify(watchedFormData));
  }, [formFieldsCount]);

  const travelersObject = {};
  let travelersString = 'clients: ';

  // ##### Komarov 2025-07-08
  watchedFormData?.travelersData?.forEach(traveler => {
    travelersObject[`Traveler ${traveler.site_client_id} gender`] =
      traveler.travelerGender;
    travelersObject[`Traveler ${traveler.site_client_id} prefix`] =
      traveler.travelerPrefix;
    travelersObject[`Traveler ${traveler.site_client_id} name`] =
      traveler.travelerFirstName;
    travelersObject[`Traveler ${traveler.site_client_id} surname`] =
      traveler.travelerLastName;
    travelersObject[`Traveler ${traveler.site_client_id} category`] =
      traveler.travelerCategory;
    travelersString += `${traveler.site_client_id}: pr.: ${traveler.travelerPrefix}, name: ${traveler.travelerFirstName}, surname: ${traveler.travelerLastName}, gen.: ${traveler.travelerGender} , cat.: ${traveler.travelerCategory} `;
  });

  const getCommentsWithTravelers = () => {
    if (buyerComments) {
      const commentsWithTravelersShort = `${buyerComments} | ${travelersString}`;
      const commentsWithTravelersFitsFieldLength =
        commentsWithTravelersShort.length <= config.formCommentsStringLength;
      if (commentsWithTravelersFitsFieldLength) {
        return commentsWithTravelersShort;
      }
      const travelersStringLong = `... (${RequiresClarification}) | ${travelersString}`;
      return `${buyerComments.slice(0, config.formCommentsStringLength - travelersStringLong.length)}${travelersStringLong}`;
    }
    return travelersString;
  };

  // ##### 25-04-30 Komarov
  useEffect(() => {
    if (!(available_now && clicked && hotelrates4?.success)) {
      return;
    }
    const data = {
      // ##### 25-05-09 Komarov
      bookings: [
        {
          service_type_id: cart?.service_type_id,
          start: cart?.start,
          end: cart?.end ? cart?.end : null,
          contract_id: cart?.contract_id, //former tour_id
          tariff_id: cart?.tariff_id, //former tour_tariff_id
          room_id: cart?.room_id, //former tour_room_id
          numberofunits:
            parseInt(cart?.service_type_id) === parseInt(1)
              ? parseInt(cart?.numberofunits)
              : parseInt(1),
          // ##### 25-04-21 Komarov
          id: cart?.id, // hotel's id
          hotel_id: cart?.id, // hotel's id
          hotel_room_id:
            parseInt(cart?.service_type_id) === parseInt(1)
              ? cart?.hotel_room_id
              : null, //only for package tour
          hotel_rate_id:
            parseInt(cart?.service_type_id) === parseInt(1)
              ? cart?.hotel_rate_id
              : null, // only for package tours
          calculation_data: {
            adults: cart?.adults,
            children: cart?.children,
            // ##### 25-05-09 Komarov
            amount: Math.fround(actualAmount).toFixed(2), // цену заказа берём уже из hotelrates4
          },
          // comments: buyerCommentsInput,
          // comments: buyerComments,
          comments: getCommentsWithTravelers(),
        },
      ],
    };

    const postObject = getPostObject({
      action: 'AddToCartRQ',
      user_id: currentUser.user_id,
      refpartner: company_id,
      language: locale,
      data,
    });

    // ##### 26-08-12 Komarov
    smartPost(postObject.url, postObject.parameters)
      .then(response => {
        const responseData = response?.data?.[0];
        if (!responseData?.success) {
          setSmartServiceDataErrorMessage(
              responseData.errors?.length > 0 ? responseData.errors[0] : ''
          );
        }
        setSmartServiceData(responseData);
      })
      .catch(error => {
        setSmartServiceData(undefined);
        console.error('[axios error]: ', error);
      });
  }, [
    // ##### 25-05-09 Komarov
    actualAmount,
    hotelrates4?.success,
    cart?.service_type_id,
    cart?.start,
    cart?.end,
    cart?.contract_id,
    cart?.tariff_id,
    cart?.room_id,
    cart?.numberofunits,
    // ##### 25-04-21 Komarov
    cart?.id, // hotel's id
    cart?.hotel_room_id,
    cart?.hotel_rate_id,
    cart?.adults,
    cart?.children,
    cart?.refpartner,
    currentUser.user_id,
    // ##### 24-03-21 Komarov
    company_cipher,
    buyerComments,
    clicked,
  ]); // (Долбим) Посылаем запросы, пока Твид не выдаст twid_reference

  // ##### 25-04-30 Komarov
  useEffect(() => {
    // ##### 24-04-23 Komarov: TODO: Сделать запрос к action для регистрации заявки Под запрос
    if (!(!available_now && clicked)) {
      return;
    }

    // ##### 25-01-14 Komarov
    const data = {
      // ##### 25-02-12 Komarov
      company_cipher: company_cipher || '',
      bookings: [
        {
          name: buyerFirstName,
          surname: buyerLastName,
          // ##### 25-05-16 Komarov
          email: buyerEmail,
          phone: buyerPhone,
          service_type_id: cart?.service_type_id,
          start: cart?.start,
          end: cart?.end ? cart?.end : null,
          contract_id: cart?.contract_id, //former tour_id
          tariff_id: cart?.tariff_id, //former tour_tariff_id
          room_id: cart?.room_id, //former tour_room_id
          numberofunits:
            parseInt(cart?.service_type_id) === parseInt(1)
              ? parseInt(cart?.numberofunits)
              : parseInt(1),
          // ##### 25-04-21 Komarov
          id: cart?.id, // hotel's id
          hotel_id: cart?.id, // hotel's id
          star_rating: cart?.hotel_category.length,
          city_id: cart?.city_id,
          hotel_room_id:
            parseInt(cart?.service_type_id) === parseInt(1)
              ? cart?.hotel_room_id
              : '', //only for package tour
          hotel_rate_id:
            parseInt(cart?.service_type_id) === parseInt(1)
              ? cart?.hotel_rate_id
              : '', // only for package tours
          calculation_data: {
            adults: cart?.adults,
            children: cart?.children,
            amount: Math.fround(actualAmount).toFixed(2),
          },
          // comments: buyerComments,
          comments: getCommentsWithTravelers(),
          // ##### 24-06-11 Komarov
          agreedPrice: agreedPrice === '' ? 0 : agreedPrice,
          ...travelersObject,
        },
      ],
    };

    const postObject = getPostObject({
      action: 'FormOnRequestRQ',
      user_id: currentUser.user_id,
      refpartner: company_id,
      language: locale,
      data,
    });

    const dataObject = {
      data,
      subject: 'Booking On Request',
    };

    // ##### 26-07-30 Komarov
    smartPost(postObject.url, postObject.parameters).then(res => {
      setRegistrationTimestamp(res[0].data.timestamp);
      axios.post(
        `${process.env.REACT_APP_URL}online_summary_request`,
        JSON.stringify({ dataObject }),
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
    });
  }, [
    // ##### 25-05-10 Komarov
    actualAmount,
    cart?.service_type_id,
    cart?.start,
    cart?.end,
    cart?.contract_id,
    cart?.tariff_id,
    cart?.room_id,
    cart?.numberofunits,
    // ##### 25-04-21 Komarov
    cart?.id, // hotel's id
    cart?.hotel_room_id,
    cart?.hotel_rate_id,
    cart?.adults,
    cart?.children,
    cart?.refpartner,
    currentUser.user_id,
    // ##### 24-03-21 Komarov
    company_cipher,
    buyerComments,
    // ##### 24-06-11 Komarov
    agreedPrice,
    clicked,
  ]);

  const getFieldLabel = fieldName => {
    switch (fieldName) {
      case 'buyerFirstName':
        return FirstName;
      case 'buyerLastName':
        return LastName;
      case 'buyerPhone':
        return BuyerPhoneNumber;
      case 'buyerEmail':
        return EmailAddress;
      case 'agreeTermsConditions':
        return AgreeTermsCond;
      case 'travelersData':
        return TravelerInformation;
      default:
        return fieldName;
    }
  };

  // Вспомогательный компонент для вывода ошибок
  const ErrorMessage = ({ errors, getFieldLabel }) => {
    const errorKey = Object.keys(errors)[0];
    if (!errorKey) return null;
    const errorLabel = getFieldLabel(errorKey);
    let errorMessage;
    if (errorKey === 'travelersData') {
      errorMessage =
        errors[errorKey][Object.keys(errors[errorKey])[0]]?.message ||
        errors[errorKey][Object.keys(errors[errorKey])[0]][
          Object.keys(errors[errorKey][Object.keys(errors[errorKey])[0]])[0]
        ]?.message;
    } else {
      errorMessage = errors[errorKey].message;
    }
    return (
      <>
        <strong>{errorLabel}: </strong>
        {errorMessage}
      </>
    );
  };
  ErrorMessage.propTypes = {
    errors: PropTypes.object.isRequired,
    getFieldLabel: PropTypes.func.isRequired,
  };

  // ##### 24-04-19 Komarov
  return (
    <form
      className={className}
      onSubmit={handleSubmit(onSubmit)}
      data-component="ClientDetailsForm"
    >
      <div className="ReadOnlyBlock">
        {/* ##### 24-04-25 Komarov */}
        <div className="ReadOnlyElement">
          <label className="FormLabelForReadOnlyDiv">{SupplierForm_city}</label>
          <input value={cityTitle} readOnly />
        </div>
        <div className="ReadOnlyElement">
          <label className="FormLabelForReadOnlyDiv">{HotelTitle}</label>
          <input value={decodeURIComponent(hotelTitle)} readOnly />
        </div>
        {/* ##### 24-04-29 Komarov */}
        <div className="ReadOnlyElement">
          <label className="FormLabelForReadOnlyDiv">
            {StarRatingLabelText}
          </label>
          <input value={starRatingValue} readOnly />
        </div>
        <div className="ReadOnlyElement">
          <label className="FormLabelForReadOnlyDiv">{RoomType}</label>
          <input value={decodeURIComponent(cart?.room_name)} readOnly />
        </div>
        <div className="ReadOnlyElement">
          <label className="FormLabelForReadOnlyDiv">{Tariff}</label>
          <input
            value={
              // ##### 24-04-26 Komarov
              cart?.tariff_type_name +
              (parseInt(cart?.nrf) === 1 ? ' Non Refundable' : '')
            }
            readOnly
          />
        </div>
        <div className="ReadOnlyElement">
          <label className="FormLabelForReadOnlyDiv">{Adults}</label>
          <input value={cart?.adults} readOnly />
        </div>
        {parseInt(cart?.children) !== 0 && (
          <div className="ReadOnlyElement">
            <label className="FormLabelForReadOnlyDiv">{Children}</label>
            <input value={cart?.children} readOnly />
          </div>
        )}
        <div className="ReadOnlyElement">
          <label className="FormLabelForReadOnlyDiv">{Rooms}</label>
          <input value={cart?.numberofunits} readOnly />
        </div>
        {cart?.amount !== 'No price was shown' && (
          <div className="ReadOnlyElement">
            <label className="FormLabelForReadOnlyDiv">{TotalCostShort}</label>
            <input value={Math.fround(actualAmount).toFixed(2)} readOnly />
          </div>
        )}
        {/* ##### 24-04-26 Komarov */}
        <div className="ReadOnlyElement">
          <label className="FormLabelForReadOnlyDiv">{SelectedCurrency}</label>
          <input value={currencyName} readOnly />
        </div>
        <div className="ReadOnlyElement">
          <label className="FormLabelForReadOnlyDiv">{CartDetails_3}</label>
          <input value={cart?.start} readOnly />
        </div>
        <div className="ReadOnlyElement">
          <label className="FormLabelForReadOnlyDiv">{CartDetails_4}</label>
          <input value={cart?.end} readOnly />
        </div>
        {/* ##### 24-05-23 Komarov */}
        {registrationTimestamp && (
          <div className="ReadOnlyElement">
            <label className="FormLabelForReadOnlyDiv">
              {RegistrationDateTime}
            </label>
            <input
              value={moment(registrationTimestamp).format(dateTime[locale])}
              readOnly
            />
          </div>
        )}
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '20px',
        }}
      >
        <button
          type="button"
          className="BackToRoomsButton"
          onClick={() => {
            // Reset form while preserving read-only values
            const readOnlyValues = {
              cityTitle,
              hotelTitle,
              starRatingValue,
              RoomType: cart?.room_name,
              Tariff:
                cart?.tariff_type_name +
                (parseInt(cart?.nrf) === 1 ? ' Non Refundable' : ''),
              adults: cart?.adults,
              children: cart?.children,
              numberofunits: cart?.numberofunits,
              currencyName,
              start: cart?.start,
              end: cart?.end,
              actualAmount:
                (actualAmount && Math.fround(actualAmount).toFixed(2)) ||
                'No price was shown',
              buyerPhone: '', // Explicitly reset the phone field
              bookForYourself: false,
              shouldCopyName: false,
              agreeTermsConditions: false,
            };
            reset(readOnlyValues);
            // Force reset the phone field value
            setValue('buyerPhone', '');
          }}
        >
          {ClearForm}
        </button>
      </div>
      {Object.keys(errors).length > 0 && (
        <div
          style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            zIndex: 1000,
            minWidth: '300px',
          }}
        >
          <Toast
            show={true}
            style={{
              backgroundColor: '#dc3545',
              color: 'white',
              borderRadius: '8px',
              opacity: 1,
              transform: 'translateX(0)',
              transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
              animation: 'slideIn 0.5s ease-out',
            }}
          >
            <Toast.Body
              style={{
                backgroundColor: '#dc3545',
                color: 'white',
                padding: '12px 16px',
                borderRadius: '8px',
                animation: 'fadeIn 0.5s ease-out',
              }}
            >
              <ErrorMessage errors={errors} getFieldLabel={getFieldLabel} />
            </Toast.Body>
          </Toast>
        </div>
      )}
      {/* ##### 26-07-30 Komarov */}
      {!isB2B && (
        <div className="InputBlock">
          <label className="FormLabel">
            {
              // ##### 23-10-04 Komarov
              markRequired(BuyerNameSurname)
            }
          </label>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-evenly',
              width: '100%',
            }}
          >
            <select
              {...register('buyerPrefix')}
              // ##### Komarov 2025-07-08
              style={{ marginRight: '0.5vw' }}
            >
              {
                // ##### 24-03-21 Komarov
                ClientTitles?.map(item => {
                  return (
                    // ##### 23-04-12 Komarov
                    <option key={uniqueId()}>{item}</option>
                  );
                })
              }
            </select>

            <input
              {...register('buyerFirstName')}
              type={'text'}
              // ##### 25-05-19 Komarov
              placeholder={FirstName}
              maxLength="50"
              style={{
                width: '45%',
                marginRight: '0.5vw',
              }}
            />

            <input
              {...register('buyerLastName')}
              type={'text'}
              // ##### 25-05-19 Komarov
              placeholder={LastName}
              maxLength="50"
              style={{ width: '45%' }}
              // required
            />
          </div>
        </div>
      )}
      {!isB2B && (
        <div className="InputBlock">
          <label className="FormLabel" htmlFor="phone">
            {
              // ##### 23-10-04 Komarov
              markRequired(BuyerPhoneNumber)
            }
          </label>
          <Controller
            name="buyerPhone"
            control={control}
            render={({ field }) => (
              <InputMask
                {...field}
                mask="+999 99 999 9999"
                maskChar="_"
                alwaysShowMask={true}
              >
                {inputProps => (
                  <input
                    {...inputProps}
                    type="tel"
                    placeholder={PleaseInputPhoneNumber}
                    id="phone"
                  />
                )}
              </InputMask>
            )}
          />
        </div>
      )}
      {!isB2B && (
        <div className="InputBlock">
          <label className="FormLabel">
            {
              // ##### 23-10-04 Komarov
              markRequired(EmailAddress)
            }
          </label>

          <input
            {...register('buyerEmail')}
            type={'email'}
            // ##### 25-05-19 Komarov
            placeholder={EnterYourEmailAdddress}
            // required
          />
        </div>
      )}
      {/* ##### 24-04-17 Komarov */}
      <div className="InputBlock">
        <label className="FormLabel">{Comments}</label>

        <input
          {...register('buyerComments')}
          type={'text'}
          // ##### 25-05-19 Komarov
        />
      </div>
      {/* ##### 24-06-11 Komarov */}
      {cart?.amount === 'No price was shown' && (
        <div className="InputBlock">
          <label className="FormLabel">{AgreedPrice}</label>

          <input {...register('agreedPrice')} type={'text'} />
        </div>
      )}
      {/* ##### 26-07-30 Komarov */}
      {!isB2B && (
        <>
          {/* ##### 25-05-20 Komarov */}
          <div
            // ##### 24-04-29 Komarov
            className="ReadOnlyBlock formCheckboxLabel"
          >
            <Controller
              name="bookForYourself"
              control={control}
              render={({ field }) => (
                <input {...field} type="checkbox" checked={bookForYourself} />
              )}
            />
            <div className="formCheckboxLabel">
              {
                // ##### 23-10-04 Komarov
                DoYouBookForYourself
              }
            </div>
          </div>
          {bookForYourself && (
            <div className="ReadOnlyBlock formCheckboxLabel">
              <Controller
                name="shouldCopyName"
                control={control}
                render={({ field }) => (
                  <input {...field} type="checkbox" checked={shouldCopyName} />
                )}
              />
              <div className="formCheckboxLabel">
                {
                  // ##### 23-10-04 Komarov
                  ShouldCopyName
                }
              </div>
            </div>
          )}
        </>
      )}
      {youNeedTravelersCount > 0 && (
        <>
          {travelerFields.map((field, i) => (
            <div
              key={field.id}
              className="InputBlock"
              style={{ position: 'relative' }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  // ##### Komarov 2025-06-04: justifyContent: "space-between" - чтобы текст ярлыка располагался в левом крае, а кнопка удаления, если она есть, - в правом.
                  justifyContent: 'space-between',
                  width: '100%',
                  // alignItems: "center",
                }}
              >
                <label className="FormLabel">
                  {/* ##### Komarov 2025-07-08 */}
                  {markRequired(`${TravelerName} ${i + 1}`)}
                </label>
                {i >= youNeedTravelersCount && (
                  <button
                    type="button"
                    onClick={() => {
                      removeTraveler(i);
                      setYouCanAddTravelersCount(prev => prev + 1);
                    }}
                    style={{
                      marginLeft: 8,
                      background: '#dc3545',
                      color: 'white',
                      border: 'none',
                      borderRadius: '50%',
                      width: 28,
                      height: 28,
                      fontSize: 18,
                      cursor: 'pointer',
                    }}
                    title={RemoveTraveler}
                  >
                    ×
                  </button>
                )}
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-evenly',
                  width: '100%',
                  // alignItems: "center",
                }}
              >
                <input
                  type="hidden"
                  {...register(`travelersData.${i}.site_client_id`)}
                  value={field.site_client_id}
                  readOnly
                />
                <select
                  {...register(`travelersData.${i}.travelerPrefix`)}
                  // ##### Komarov 2025-07-08
                  style={{ marginRight: '0.5vw' }}
                >
                  {ClientTitles?.map(item => (
                    <option key={item}>{item}</option>
                  ))}
                </select>
                <input
                  {...register(`travelersData.${i}.travelerFirstName`, {
                    // ##### Komarov 2025-07-08
                    required: i === 1,
                  })}
                  type="text"
                  placeholder={FirstName}
                  maxLength="50"
                  style={{ width: '45%', marginRight: '0.5vw' }}
                  readOnly={shouldCopyName && i === 0}
                />
                <input
                  {...register(`travelersData.${i}.travelerLastName`, {
                    // ##### Komarov 2025-07-08
                    required: i === 1,
                  })}
                  type="text"
                  placeholder={LastName}
                  maxLength="50"
                  style={{ width: '45%' }}
                  readOnly={shouldCopyName && i === 0}
                />
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  width: '100%',
                  alignItems: 'baseline',
                  marginTop: '0.5em',
                  marginBottom: '-0.6em',
                }}
              >
                <label className="FormLabel">
                  {/* ##### Komarov 2025-07-08 */}
                  {Gender}
                </label>
                <select {...register(`travelersData.${i}.travelerGender`)}>
                  {ClientGenders.map(item => (
                    <option key={item}>{item}</option>
                  ))}
                </select>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  width: '100%',
                  alignItems: 'baseline',
                  marginTop: '0.5em',
                  marginBottom: '-0.6em',
                }}
              >
                <label className="FormLabel">{`${AgeCategory} ${i + 1}`}</label>
                <select {...register(`travelersData.${i}.travelerCategory`)}>
                  {ClientCategories[locale]?.map(item => (
                    <option key={item}>{item}</option>
                  ))}
                </select>
              </div>
            </div>
          ))}
        </>
      )}
      {youCanAddTravelersCount > 0 && (
        <div
          style={{
            margin: '20px 0',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            // alignItems: "center",
          }}
        >
          {[...Array(youCanAddTravelersCount)].map((_, idx) => (
            <button
              key={idx}
              className="BackToRoomsButton"
              type="button"
              onClick={() => {
                const currentIds = Array.isArray(travelerFields)
                  ? travelerFields.map(t => t?.site_client_id || 0)
                  : [];
                const maxId =
                  currentIds.length > 0 ? Math.max(...currentIds) : 0;
                appendTraveler({
                  site_client_id: maxId + 1,
                  travelerPrefix: ClientTitles[0],
                  // ##### Komarov 2025-07-08
                  travelerGender: ClientGenders[0],
                  travelerCategory: ClientCategories[locale][0],
                  travelerFirstName: '',
                  travelerLastName: '',
                });
                setYouCanAddTravelersCount(prev => Math.max(prev - 1, 0));
              }}
            >
              {AddTraveler}
            </button>
          ))}
        </div>
      )}
      <>
        <div
          // ##### 24-04-29 Komarov
          className="ReadOnlyBlock TermsConditions"
        >
          <Controller
            name="agreeTermsConditions"
            control={control}
            render={({ field }) => (
              <input
                {...field}
                type="checkbox"
                disabled={clicked}
                checked={agreeTermsConditions}
              />
            )}
          />
          <div
            className="TermsConditions"
            role="button"
            tabIndex={0}
            aria-label={AgreeTermsCond}
            onClick={ReadTermsFunc}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                ReadTermsFunc();
              }
            }}
          >
            {AgreeTermsCond}
          </div>
        </div>
        {showTerms === true ? (
          <TermsConditions
            readTerms={showTerms}
            closeTermsConditions={closeTermsConditions}
          />
        ) : null}
      </>
      {/* ##### 24-04-19 Komarov */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-evenly',
          // alignItems: "center",
        }}
      >
        {/* ##### 24-04-24 Komarov */}
        <ConfirmButton clicked={clicked} available_now={available_now} />

        {/* ##### 24-04-19 Komarov */}
        <button
          type="button"
          className="BackToRoomsButton"
          onClick={backToRooms}
        >
          {
            // ##### 23-10-04 Komarov
            BackToRooms
          }
        </button>
      </div>
      {available_now && clicked === true && smart_service.smart_reference ? (
        <>
          <OnlineSummary
            // ##### 23-02-20 Komarov
            smart_service_id={smart_service.service_id}
            cart={cart}
            watchedFormData={watchedFormData}
          />
          <SaveReference
            customer_reference={smart_service.customer_reference}
          />
          {
            // ##### 26-07-30 Komarov
            !isB2B && (
            <Pay
              //  ##### 23-02-20 Komarov
              smart_service_id={smart_service.service_id}
              smart_order_id={smart_service.booking_id}
              smart_reference={smart_service.smart_reference}
              service_number={smart_service.service_number}
              cart={cart}
              actualAmount={Math.fround(actualAmount).toFixed(2)}
              // ##### 24-03-21 Komarov
              client={`${buyerFirstName} ${buyerLastName}`}
            />)
          }
        </>
      ) : smartServiceDataErrorMessage.length > 0 ? (
        <h2>{smartServiceDataErrorMessage}</h2>
      ) : available_now &&
        clicked === true &&
        !smart_service.smart_reference ? (
        <>
          <OfflineSummary
            // wait={10000}
            wait={5000}
          />
          <IncompleteSendEmail
            smartServiceDataErrorMessage={smartServiceDataErrorMessage}
            smart_service_id={smart_service.service_id}
            cart={cart}
            watchedFormData={watchedFormData}
          />
        </>
      ) : null}
    </form>
  );
};

ClientDetailsForm.propTypes = {
  className: PropTypes.string,
};

export default ClientDetailsForm;
